export default {"src":"/_next/static/media/btcz.379c990c.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};